import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faTimes } from "@fortawesome/free-solid-svg-icons";
import ListCatalogues from "./ListCatalogues";

const ListCategoriesCatalogue = ({ catalogue, categorys, collection }) => {
  const [showModal, setShowModal] = useState("modal_no_active");

  function handleClick() {
    if (showModal === "modal_no_active") {
      setShowModal("modal_active");
    } else {
      setShowModal("modal_no_active");
    }
  }

  return (
    <div className="affiche-pdf">
      <FontAwesomeIcon icon={faLink} />
      <span>{catalogue.category}</span>
      <div id="modal" className={showModal}>
        <button
          className="button-circle-top"
          onClick={handleClick}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <ListCatalogues
          catalogue={catalogue}
          collection={collection}
          categorys={categorys}
        />
      </div>
      <div className="button_modal" onClick={handleClick} />
    </div>
  );
};

export default ListCategoriesCatalogue;
